import { render, staticRenderFns } from "./OpinionMailboxEdit.vue?vue&type=template&id=a8968764"
import script from "./OpinionMailboxEdit.vue?vue&type=script&lang=js"
export * from "./OpinionMailboxEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports